const siglasEstados = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
];

export const statusRebateUsina = [
    "A iniciar",
    "Aguardando Consolidação",
    "Aberto",
    "Aguardando Processamento",
    "Processado",
    "Aprovado",
    "Erro",
];

export const tipoRebateFilterOptions = [
    { label: "Todos", value: "Todos" },
    { label: "Sem Rebate", value: 1 },
    { label: "Imposto", value: 2 },
    { label: "Regra de Compensação", value: 3 },
];

export const tipoRebateDialogOptions = [...tipoRebateFilterOptions.slice(1)];

export const statusOptions = [
    { label: "Todos", value: "Todos" },
    { label: "Ativo", value: "Ativo" },
    { label: "Inativo", value: "Inativo" },
];

export const statusFilterOptions = {
    Todos: "",
    Ativo: true,
    Inativo: false,
    "": "",
};

export const tipoCalculoDialogOptions = [
    { label: "Cálculo do Sistema", value: 1 },
    { label: "Importação de Planilha", value: 2 },
];

export const estadosOptions = siglasEstados.map((sigla) => ({ label: sigla, value: sigla }));

export const classeOptions = [
    { value: 1, label: "RESIDENCIAL" },
    { value: 2, label: "INDUSTRIAL" },
    { value: 3, label: "COMERCIAL" },
    { value: 4, label: "RURAL" },
    { value: 5, label: "PODER PÚBLICO" },
    { value: 6, label: "ILUMINAÇÃO PÚBLICA" },
    { value: 7, label: "SERVIÇO PÚBLICO" },
    { value: 8, label: "CONSUMO PRÓPRIO" },
    { value: 9, label: "SUPRIMENTO" },
    { value: 10, label: "CAP EMERGENCIAL" },
];

export const habilitadoOptions = [
    { label: "Todos", value: "Todos" },
    { label: "Sim", value: "Sim" },
    { label: "Não", value: "Nao" },
];

export const habilitadoFilterOptions = { Todos: "", Sim: true, Nao: false, "": "" };

export const tipoDadoOptions = [
    { value: "T", label: "Texto" },
    { value: "N", label: "Numérico" },
    { value: "D", label: "Decimal" },
];

export const tipoCampoOptions = [
    { value: "F", label: "Fatura" },
    { value: "C", label: "Calculado" },
    { value: "R", label: "Referência" },
    { value: "H", label: "Histórico" },
];
